<template>
  <a-card :bordered="false">
    <div style="margin-bottom: 15px;">
      <a-input placeholder="用户手机号" style="width:200px;margin-right:2%;" v-model="queryParams.serviceMobilePhone"/>
      <a-button type="primary" @click="$refs.tableList.refresh(true)">查询</a-button>
    </div>
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="serviceUrl"
      query-path="service/getServiceRecordUserServiceList"
    >
      <span slot="action" slot-scope="rowItem">
        <a-button type="primary" size="small"
                  @click="openlistdialog(rowItem.record.serviceMemberId,rowItem.record.serviceId,rowItem.record.serviceMobilePhone)">查看</a-button>
      </span>
    </custom-page-table>
    <a-modal
      title="咨询记录"
      :footer="null"
      :visible="listVisible"
      @cancel="handleCancel"
      :afterClose="handleClose"
      :width=600
    >
      <div class="listbox" id="contents">
        <div class="" v-for="(item,index) in detailServiceList" :key="index" :data-id="item.serviceId">
          <div class="boxleft" v-if="item.serviceMemberType==1">
            <div class="leftheadwidth">
              <div class="lefthead" v-if="item.serviceUserLogo"
                   :style="{'background-image': 'url('+item.serviceUserLogo+')'}"></div>
              <div class="lefthead" v-else></div>
            </div>
            <div class="leftwapper">
              <div class="wappername">
                <div class="name">{{ item.serviceUserName }}</div>
                <div class="time">{{ item.serviceCreateTime }}</div>
              </div>
              <div class="wapperbody" v-if="item.serviceMessageType==1" v-html="item.serviceContent"></div>
              <div class="wapperbody" v-else>
                <img :src="item.serviceContent"/>
              </div>
            </div>
          </div>
          <div class="boxright" v-else>
            <div class="rightwapper">
              <div class="wappername rightname">
                <div class="time timetight">{{ item.serviceCreateTime }}</div>
                <div class="name">{{ item.userinfoMerchantName }}</div>
              </div>
              <div class="wapperbody" v-if="item.serviceMessageType==1" v-html="item.serviceContent"
                   style="text-align: right;"></div>
              <div class="wapperbody" v-else style="text-align: right;">
                <img :src="item.serviceContent"/>
              </div>
            </div>
            <div class="head">
              <div class="leftheadwidth">
                <div class="righthead" v-if="item.userinfoMerchantLogo"
                     :style="{'background-image': 'url('+item.userinfoMerchantLogo+') '}"></div>
                <div class="righthead" v-else>头像</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demo-input-suffix" style="margin-top:10px;">
        <a-textarea
          style="margin-top:10px;"
          :rows="4"
          show-word-limit
          placeholder="请输入内容，输入: @问答模板ID  发送自动识别为内容"
          v-model="serviceContent"
          resize="none"
        >
        </a-textarea>
      </div>
      <div class="demo-input-suffix" style="margin-top:10px;">
        <a-upload
          class="upload-demo"
          :action="actionImageUrl"
          :multiple="false"
          @change="fileInfo=>handleChange(fileInfo,2)"
          :showUploadList="false">
          <a-button :loading="loading" type="primary">点击上传</a-button>
          <div style="margin-top:10px">只能上传jpg/png文件，且不超过1M</div>
        </a-upload>
      </div>
      <span class="dialog-footer">
      <a-button type="primary" @click="addServiceRecord(0)">发送</a-button>
    </span>
    </a-modal>
    <SettingComponent :visible="settingVisible" @change="changeEvent" @submit="submitSetting"></SettingComponent>
  </a-card>
</template>

<script>
import SettingComponent from '@/views/service/serviceProvider/online/SettingComponent'

var timeInterval = ''
export default {
  name: 'OnlineServiceList',
  components: {
    SettingComponent
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'serviceMemberId'
        },
        {
          title: '咨询用户',
          dataIndex: 'serviceUserName'
        },
        {
          title: '联系电话',
          dataIndex: 'serviceMobilePhone'
        },
        {
          title: '最后沟通时间',
          dataIndex: 'serviceCreateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {},
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',   // '上传接口'
      superiorBossId: this.$store.getters.userInfo.superiorBossId,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      listVisible: false,
      serviceId: '',
      serviceMobilePhone: '',
      serviceContent: '',
      detailServiceList: [],
      bottomserviceId: '',
      topserviceId: '',
      loading: false,
      title: '',
      id: '',
      content: '',
      sendserviceMobilePhone: '',
      isNew: 1,
      fileList: [],
      serviceMemberId: '',
      settingVisible: false
    }
  },
  created() {
    this.queryParams = {
      serviceMerchantId: this.merchantId,
      servicePlatformId: this.platformId
    }
  },
  destroyed() {
    clearInterval(timeInterval)
  },
  mounted() {
  },
  methods: {
    submitSetting(value) {
      if (value == 2) {
        this.openNewPage(
          'QuestionTemplate',
          {
            serverId: this.$route.query.serverId,
            serverUniqueId: this.$route.query.serverUniqueId
          })
      }
    },
    changeEvent(e) {
      this.settingVisible = e
    },
    handleScroll() {   // '监听滚动条事件'
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.getElementById('contents').scrollTop
      //变量windowHeight是可视区的高度
      var windowHeight = document.getElementById('contents').clientHeight
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.getElementById('contents').scrollHeight
      //滚动条到底部的条件
      // this.getLogUtils().logWithTag(scrollTop+'========'+windowHeight+'==='+scrollHeight)
      if (scrollTop + windowHeight == scrollHeight) {
        //写后台加载数据的函数
        this.isNew = 1
        this.getServiceRecordDetailServiceList(this.serviceMemberId, this.serviceId, this.queryParams.serviceMobilePhone, 0)
      } else if (scrollTop == 0) {
        this.isNew = 0
        this.getServiceRecordDetailServiceList(this.serviceMemberId, this.serviceId, this.queryParams.serviceMobilePhone, 1)
      }
    },
    //  图片上传成功后
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        const url = this.getLatestUrlFromFileList(info.fileList)
        this.imgurl = url
        this.loading = false
        this.addServiceRecord(1)
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    handleClose() {
      clearInterval(timeInterval)
      this.isNew = 1
      this.bottomserviceId = ''
      this.topserviceId = ''
      this.detailServiceList = []
    },
    addovertype() {    // '新增信息完毕后 执行 '
      timeInterval = setInterval(function() {
        this.isNew = 1
        this.getServiceRecordDetailServiceList(this.serviceMemberId, this.serviceId, this.queryParams.serviceMobilePhone, 0)
      }, 1000)
      document.getElementById('contents').addEventListener('scroll', this.handleScroll)
    },
    // '发送消息'
    addServiceRecord(type) {
      var data = new Object()
      if (type == 0) {
        if (this.serviceContent == '') {
          this.$message.error('信息内容不能为空')
          return false
        }
        data.serviceMessageType = 1
        data.serviceContent = this.serviceContent
      } else {
        data.serviceMessageType = 2
        data.serviceContent = this.imgurl
      }
      clearInterval(timeInterval)
      document.getElementById('contents').removeEventListener('scroll', this.handleScroll)
      data.serviceId = this.serviceId
      data.serviceMemberId = this.serviceMemberId
      // if(this.loginType==1){
      //   data.serviceMemberType=2;
      //   data.serviceStaffId=0;
      // }else{
      //   data.serviceMemberType=3;
      //   data.serviceStaffId=this.merchantId;
      // }

      //这里固定,只有运营商;
      data.serviceMemberType = 2
      data.serviceStaffId = 0
      //这里固定,只有运营商

      data.serviceMerchantId = this.superiorBossId
      data.servicePlatformId = this.platformId
      this.getHttpServices().getServerApiService().post('service/addServiceRecord', data)
        .then(res => {
          this.serviceContent = ''
          this.bottomserviceId = res.serviceId
          var obj = new Object()
          obj.serviceContent = res.serviceContent.replace(/\n/g, '<br/>')
          obj.serviceCreateTime = res.serviceCreateTime
          obj.serviceId = res.serviceId
          obj.serviceIsRead = res.serviceIsRead
          obj.serviceMemberId = res.serviceMemberId
          obj.serviceMemberType = res.serviceMemberType
          obj.serviceMessageType = res.serviceMessageType
          obj.serviceUserLogo = res.serviceUserLogo
          obj.serviceUserName = res.serviceUserName
          obj.userinfoMerchantLogo = res.userinfoMerchantLogo
          obj.userinfoMerchantName = res.userinfoMerchantName
          this.detailServiceList.push(obj)
          timeout = setTimeout(function() {
            var ele = document.getElementById('contents')
            ele.scrollTop = ele.scrollHeight
          }, 100)
          this.addovertype()
        }).catch(err => {
      })
    },
    // 查看咨询列表详情
    getServiceRecordDetailServiceList(id, serviceId, serviceMobilePhone, type) {
      this.sendserviceMobilePhone = serviceMobilePhone
      this.serviceMemberId = id
      var data = new Object()
      if (this.isNew == 1) {
        data.serviceId = this.bottomserviceId
      } else {
        data.serviceId = this.topserviceId
      }
      data.isNew = this.isNew
      data.serviceMemberId = id
      data.serviceMerchantId = this.superiorBossId
      //这里固定,只有运营商;
      // if(this.loginType==1){
      //   data.serviceStaffId =-1;
      // }else{
      //   data.serviceStaffId =this.merchantId;
      // }
      data.serviceStaffId = -1
      //这里固定,只有运营商;
      data.servicePlatformId = this.platformId
      this.getHttpServices().getServerApiService().post('service/getServiceRecordDetailServiceList', data)
        .then(res => {
          if (this.isNew == 1) {
            res.forEach(item => {
              var obj = new Object()
              obj.serviceContent = item.serviceContent.replace(/\n/g, '<br/>')
              obj.serviceCreateTime = item.serviceCreateTime
              obj.serviceId = item.serviceId
              obj.serviceIsRead = item.serviceIsRead
              obj.serviceMemberId = item.serviceMemberId
              obj.serviceMemberType = item.serviceMemberType
              obj.serviceMessageType = item.serviceMessageType
              obj.serviceUserLogo = item.serviceUserLogo
              obj.serviceUserName = item.serviceUserName
              obj.userinfoMerchantLogo = item.userinfoMerchantLogo
              obj.userinfoMerchantName = item.userinfoMerchantName
              this.detailServiceList.push(obj)
            })
          } else {
            for (var i = res.length - 1; i >= 0; i--) {
              var obj = new Object()
              obj.serviceContent = res[i].serviceContent.replace(/\n/g, '<br/>')
              obj.serviceCreateTime = res[i].serviceCreateTime
              obj.serviceId = res[i].serviceId
              obj.serviceIsRead = res[i].serviceIsRead
              obj.serviceMemberId = res[i].serviceMemberId
              obj.serviceMemberType = res[i].serviceMemberType
              obj.serviceMessageType = res[i].serviceMessageType
              obj.serviceUserLogo = res[i].serviceUserLogo
              obj.serviceUserName = res[i].serviceUserName
              obj.userinfoMerchantLogo = res[i].userinfoMerchantLogo
              obj.userinfoMerchantName = res[i].userinfoMerchantName
              this.detailServiceList.unshift(obj)
            }
          }
          this.topserviceId = this.detailServiceList.length != 0 ? this.detailServiceList[0].serviceId : res[0].serviceId
          this.bottomserviceId = this.detailServiceList.length != 0 ? this.detailServiceList[this.detailServiceList.length - 1].serviceId : res[res.length - 1].serviceId
          var ele = document.getElementById('contents')
          if (type == 0 && res.length != 0) {
            timeScrollHeight = setTimeout(function() {
              ele.scrollTop = ele.scrollHeight
            }, 60)
          }
        }).catch(err => {
      })
    },
    //  查看咨询列表详情
    openlistdialog(id, serviceId, serviceMobilePhone) {
      this.listVisible = true
      this.isNew = 1
      this.detailServiceList = []   // 清空之前的数据
      this.bottomserviceId = ''  // 获取消息的最后一个 对象的 serviceId 来进行 追加数据
      this.topserviceId = ''  //  获取消息的第一个 对象的 serviceId 来进行 追加数据
      clearInterval(timeInterval)
      var that = this
      this.getServiceRecordDetailServiceList(id, serviceId, serviceMobilePhone, 0)
      timeInterval = setInterval(function() {
        document.getElementById('contents').addEventListener('scroll', that.handleScroll)
        that.getServiceRecordDetailServiceList(id, serviceId, serviceMobilePhone, 1)
      }, 10000)
    },
    handleCancel() {
      this.listVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.listbox {
  background-color: #eeeeee;
  padding: 10px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.boxleft {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.boxright {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  justify-content: flex-end;
}

.head {
  width: 40px;
  height: 40px;
}

.leftheadwidth {
  width: 40px;
  height: 40px;
}

.lefthead {
  content: "头像";
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.righthead {
  content: "头像";
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leftwapper {
  margin-left: 10px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* flex: 1; */
}

.rightwapper {
  margin-left: 20px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* flex: 1; */
}

.wappername {
  display: flex;
  align-items: baseline !important;
}

.rightname {
  justify-content: flex-end
}

.name {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 1);
}

.time {
  font-size: 10px !important;
  color: rgba(0, 0, 0, 1);
  margin-left: 15px;
}

.timetight {
  margin-right: 15px;
}

.wapperbody {
  margin-top: 10px;
  background-color: #ffffff;
  padding: 10px;
  font-size: 14px !important;
  border-radius: 10px;
  word-wrap: break-word;
  word-break: normal;
  overflow: hidden;
  word-break: break-all;

  img {
    max-width: 100%;
  }
}

.dialog-footer {
  position: relative;
  left: 88%;
}

.number-val {
  position: absolute;
  top: -10px;
  right: 10px;
}
</style>